import React from 'react';
import Pricing from '../blocks/pricing/pricing';
import PricingBandwidth from '../blocks/pricing/pricing_bandwidth';
import PricingCard from '../blocks/pricing/pricing_card';
import PricingCdn from '../blocks/pricing/pricing_cdn';
import PricingEdgeStorage from '../blocks/pricing/pricing_edge_storage';
import PricingPerformanceComparison from '../blocks/pricing/pricing_performance_comparison';
import PricingVideoDelivery from '../blocks/pricing/pricing_video_delivery';
import { LayoutPadding } from '~/layouts';
import { PricingCardsV2 } from '../blocks/pricing/pricing_cards_v2';

type PricingProxyProps = {
  block: any;
  vars: any;
};

const PricingProxy: React.FC<PricingProxyProps> = props => {
  switch (props.block._template) {
    case 'block__pricing':
      return (
        <LayoutPadding>
          <Pricing {...props} />
        </LayoutPadding>
      );
    case 'block__pricing_unlimited_bandwidth':
      return <PricingBandwidth {...props} />;
    case 'block__pricing_card':
      return <PricingCard {...props} />;
    case 'block__pricing_cdn':
      return <PricingCdn {...props} />;
    case 'block__pricing_edge_storage':
      return <PricingEdgeStorage {...props} />;
    case 'block__pricing_performance_comparison':
      return <PricingPerformanceComparison {...props} />;
    case 'block__pricing_video_delivery':
      return <PricingVideoDelivery {...props} />;
    case 'block__pricing_v2':
      return <PricingCardsV2 block={props.block} />;
    default:
      return null;
  }
};

export default PricingProxy;
